import propTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import CloseModalButton from 'shared/components/CloseModalButton';
import TextField from 'material-ui/TextField';
import * as Colors from 'material-ui/styles/colors';
import BusyFlatButton from 'shared/components/BusyFlatButton';
import { closeDialog } from '../helpers';
import routes from 'App/routeConstants';

const style = {
  title: {
    color: Colors.gray700,
  },
  warnTitle: {
    color: '#fff',
    background: Colors.red900,
    padding: '14px 24px',
  },
  dialogBody: {
    paddingTop: '30px',
  },
  btn: {
    marginLeft: '8px',
  },
  warnBtnText: {
    color: Colors.red900,
  },
  closeIcon: {
    position: 'absolute',
    right: 8,
    top: 8,
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
  },
};

export default class RenameFolderDialog extends Component {
  static contextTypes = {
    imageUtils: propTypes.object.isRequired,
  };

  state = {
    folderName: '',
    error: '',
    busy: false,
  };

  componentWillReceiveProps(nextProps) {
    if (!this.props.open && nextProps.open) {
      const { query: { folderName } } = nextProps;
      this.setState({error: '', folderName: this.getFolderName(folderName)}, () => {
        if (this.refs.input) {
          this.refs.input.input.setSelectionRange(0, nextProps.query.folderName.length);
          this.refs.input.focus();
        }
      });
    }
  }

  getFolderName = folderName => folderName ? _.last(folderName.split('\\')) : '';

  submit = () => {
    this.setState({ busy: true });
    const { query: { folderName = ''}, currentFolder, integrated, changeFolder, router} = this.props;
    const newFolderName = this.state.folderName;
    const path = folderName ? `/${_.split(folderName, '\\').join('/')}/` : '/';

    this.context.imageUtils.doRenameFolder({ path, newFolderName }, (response) => {
      if (response && response.error && response.error.message) {
        this.setState({ error: response.error.message, busy: false });
      } else {
        this.setState({ busy: false });
        if (encodeURI(currentFolder).match(encodeURI(folderName))) {
          if (integrated) {
            changeFolder(newFolderName);
            this.closeDialog();
          } else {
            const parentFolder = _.dropRight(folderName.split('\\')).join('\\');
            const newFolderPath = !parentFolder ? newFolderName : `${parentFolder}\\${newFolderName}`;
            router.replace(`${routes.MyAccount.AssetManagerBase}/${currentFolder.replace(folderName, newFolderPath)}`);
          }
        } else {
          this.closeDialog();
        }
      }
    });
  };

  closeDialog = () => {
    if (this.props.integrated) {
      this.props.close();
    } else {
      closeDialog();
    }
  };

  handleChangeValue = (event, value) => this.setState({folderName: value});

  handleKeyUp = (e) => {
    if (e.key === 'Enter') {
      this.submit();
    }
  };

  render() {
    const { open, query: { folderName } } = this.props;
    const actions = [
      <FlatButton
        label="Cancel"
        disabled={this.state.busy}
        onClick={this.closeDialog}
      />,
      <BusyFlatButton
        labels={['Save', 'Saving']}
        busy={this.state.busy}
        onClick={this.submit}
        style={style.btn}
        disabled={this.state.folderName === folderName}
        primary
      />,
    ];
    return (
      <Dialog
        title={
          <div>
            <CloseModalButton
              onClick={this.closeDialog}
              style={style.closeIcon}
            />
            Rename your folder
          </div>
        }
        actions={actions}
        actionsContainerStyle={style.actions}
        modal={false}
        open={open}
        onRequestClose={this.closeDialog}
        titleStyle={style.title}
        style={{zIndex: 1501}}
      >
        <TextField
          hintText="Enter a meaningful name like: Shirts, Kid's Toys, Shoes etc."
          floatingLabelText="New folder's name"
          ref="input"
          value={this.state.folderName}
          errorText={this.state.error}
          onChange={this.handleChangeValue}
          onKeyUp={this.handleKeyUp}
          floatingLabelFixed
          autoFocus
          fullWidth
        />
      </Dialog>
    );
  }
}

RenameFolderDialog.propTypes = {
  open: propTypes.bool,
};